module.exports = "/assets/data/a7c0400a0fd5961fd354856f0e2ba21c-EX36.data.json";